// ── Stale counter-session auto-finish (M9.5 Phase 2, #1814) ─────────────────
//
// A counter session left running overnight must auto-save at end of day
// rather than sit forever waiting for a Finish tap that may never come. The
// one rule that MUST hold: `ended_at` on that auto-save is the LAST TAP's
// timestamp, never the wall-clock time this check happens to run — using
// "now" here would log a bogus multi-hour duration and corrupt every future
// pace/volume stat that reads the entry. See counterSession.test.js /
// counterAutoFinish.test.js for the explicit assertions.
//
// Zero-tap sessions (opened the counter, never tapped) are discarded
// entirely — cleared from localStorage, never POSTed.
import { api } from "./api";
import {
  buildTapLog,
  clearSession,
  endedAt,
  isStale,
  loadSession,
  startedAt,
  totalCount,
} from "./counterSession";
import { localISODate } from "./dates";

// Runs the check for one archer's stored session. Returns the saved
// ArrowLogOut on an auto-finish, or null if there was nothing to do.
export async function maybeAutoFinishStaleSession(archerId) {
  const session = loadSession(archerId);
  if (!session.increments.length) {
    // Nothing was ever tapped — abandoned session, discard quietly.
    clearSession(archerId);
    return null;
  }
  if (!isStale(session)) return null;

  const ended = endedAt(session);
  const payload = {
    date: localISODate(new Date(ended)),
    count: totalCount(session),
    started_at: new Date(startedAt(session)).toISOString(),
    ended_at: new Date(ended).toISOString(), // last tap — NEVER Date.now()
    tap_log: buildTapLog(session),
  };
  const saved = await api.createArrowLog(archerId, payload);
  clearSession(archerId);
  return saved;
}
